import { defineStore } from "pinia";
import { ref } from "vue";
import { GetUnreadCount } from "@/apis/message";

export const useMessageStore = defineStore("message", () => {
  const unreadCount = ref(0);
  /** When MessageView is active, HeaderContent should skip its own unread poll */
  const isMessageViewActive = ref(false);

  const fetchUnreadCount = async () => {
    try {
      const res = await GetUnreadCount();
      if (res.code === 0) {
        unreadCount.value = res.data || 0;
      }
    } catch (e) {
      // silent - user might not be logged in
    }
  };

  const clearUnread = () => {
    unreadCount.value = 0;
  };

  const decrementUnread = (count: number) => {
    unreadCount.value = Math.max(0, unreadCount.value - count);
  };

  return {
    unreadCount,
    isMessageViewActive,
    fetchUnreadCount,
    clearUnread,
    decrementUnread,
  };
});
